<template>
    <div id="Message">
        <p class="title-txt">消息列表</p>
        <div class="type-box">
            <p :class="{'fouc-bg':state==0}" @click="stateSet(0)" id="stateSet1">全部消息({{AllNum}})</p>
            <p :class="{'fouc-bg':state==2}" @click="stateSet(2)" id="stateSet2">未读消息({{noreadNum}})</p>
            <p :class="{'fouc-bg':state==1}" @click="stateSet(1)" id="stateSet3">已读消息({{readNum}})</p>
        </div>
        <!-- 列表 -->
        <div class="list-box" style="top: 77px;">
            <header class="tabs-box clearfix">
                <div :class="{'active':type==0}" @click="headClick(0)" id="headClick0"><span>全部类别</span></div>
                <div :class="{'active':type==1}" @click="headClick(1)" id="headClick1"><span>设备事件</span></div>
                <div :class="{'active':type==2}" @click="headClick(2)" id="headClick2"><span>计划任务</span></div>
                <div :class="{'active':type==3}" @click="headClick(3)" id="headClick3"><span>维保计划</span></div>
                <div :class="{'active':type==4}" @click="headClick(4)" id="headClick4"><span>平台报警</span></div>
                <div :class="{'active':type==5}" @click="headClick(5)" id="headClick5"><span>企业授权提示</span></div>
                <div :class="{'active':type==6}" @click="headClick(6)" id="headClick6"><span>平台公告</span></div>
                <div :class="{'active':type==9}" @click="headClick(9)" id="headClick7"><span>工单</span></div>
            </header>
            <div class="bg">
                <div class="company-list clearfix">
                    <ul class="list-title" style="position: relative; top: 24px ; width: 97.5%;">
                        <li class="w-18"><el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">消息标题</el-checkbox></li>
                        <li>消息类型</li>
                        <li class="w-18">时间</li>
                        <li>消息状态</li>
                        <li class="w-18">操作</li>
                    </ul>
                    <div class="scroll">
                        <el-checkbox-group v-model="checkMsg" @change="changeMsg">
                            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0 && (state==0||item.state==state)">
                                <li class="w-18" :title="item.context"><el-checkbox :label="item.id">{{''}}</el-checkbox>{{item.context}}</li>
                                <li>{{item.type == 1?'设备事件':item.type == 2?'计划任务':item.type == 3?'维保计划':item.type == 4?'平台报警':item.type == 5?'企业授权':'平台公告'}}</li>
                                <li class="w-18">{{changeTime(item.createdTime)}}</li>
                                <li>{{item.state==1?'已读':'未读'}}</li>
                                <li class="operate w-18">
                                    <span :id="`jump${i}`" @click="jump(item)" :class="{'disabled':item.type!=1&&item.type!=2&&item.type!=3}">跳转</span>
                                </li>
                            </ul>
                        </el-checkbox-group>
                    </div>
                    <ul class="list-details block" v-show="dataList.length!=0">
                        <span @click="delMsg">删除</span>
                        <span @click="read">标记已读</span>
                        <span @click="allRead">全部已读</span>
                        <span @click="allDel">全部删除</span>
                    </ul>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            totalCount:1,
            pageSize:10,
            pageNumber:1,
            dataList:[],
            state:0,
            type:0,
            nowObj:{},
            nowIndex:null,
            allMessageId:[],
            isSetState:false,
            checkAll: false,
            isIndeterminate: true,
            checkMsg:[],
            setAllNum:true,
            AllNum:0,
            readNum:0,
            noreadNum:0,
        }
    },
    components:{
        Pagination,
    },
    created() {
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getlist({pageNumber:1,length:Number(this.pageSize)});
        this.getRead()
        this.getNoRead()
    },
    methods: {
        getRead(){
            let parm={
                pageNumber:1,
                length:10,
                state:1
            }
            this.get('/Message/query',parm).then((res)=>{
                if(res.success){
                    this.readNum = res.result.totalCount
                }
            })
        },
        getNoRead(){
            let parm={
                pageNumber:1,
                length:10,
                state:2
            }
            this.get('/Message/query',parm).then((res)=>{
                if(res.success){
                    this.noreadNum = res.result.totalCount
                }
            })
        },
        // 获取消息列表
        getlist(parm){
            if(parm.state==0){
                parm.state=null
            }
            if(parm.type==0){
                parm.type=null
            }
            this.get('/Message/query',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.$store.state.messageList=res.result.data
                    this.totalCount = res.result.totalCount
                    this.allMessageId = []
                    for(let msg of this.dataList){
                        this.allMessageId.push(msg.id)
                    }
                    if(this.setAllNum){
                        this.AllNum=res.result.totalCount
                        this.setAllNum=false
                    }
                }else{
                    this.$message({
                        message: `获取列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
            // console.log(this.dataList)
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                type:this.type,
                state:this.state
            }
            this.getlist(parm)
        },
        // 修改页数
        setNum(number){
            if(this.isSetState){
                this.isSetState = false
                return
            }
            //主动修改页数不发送请求
            // console.log(number)
            this.pageNumber=number;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                type:this.type,
                state:this.state
            }
            this.getlist(parm)
        },
        // 头部标签
        headClick(i){
            this.type = i
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                type:this.type,
                state:this.state
            }
            this.getlist(parm)
        },
        // 修改状态
        stateSet(i){
            this.isSetState=true
            this.state=i
            let parm={
                pageNumber:1,
                length:this.pageSize,
                type:this.type,
                state:this.state
            }
            this.getlist(parm)
        },
        // 全选
        handleCheckAllChange(val) {
            this.checkMsg = val ? this.allMessageId : [];
            this.isIndeterminate = false;
        },
        changeMsg(value){
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.allMessageId.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.allMessageId.length;
        },
        // 删除消息
        delMsg(){
            if(this.checkMsg.length == 0){
                return
            }
            this.post('/Message/remove',{ids:this.checkMsg.toString()}).then((res)=>{
                if(res.success){
                    let parm={
                        pageNumber:this.pageNumber,
                        length:this.pageSize,
                        type:this.type,
                        state:this.state
                    }
                    this.getRead()
                    this.getNoRead()
                    this.AllNum = this.AllNum-this.checkMsg.length
                    this.getlist(parm)
                    this.$message({
                        message: `删除成功`,
                        type: 'success'
                    });
                    this.checkMsg=[]
                }else{
                    this.$message({
                        message: `删除失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 标记已读
        read(){
            if(this.checkMsg.length == 0){
                return
            }
            this.post('/Message/setReadState',{ids:this.checkMsg.toString()}).then((res)=>{
                if(res.success){
                    // console.log(this.checkMsg)
                    for(let id of this.checkMsg){
                        for(let i in this.dataList){
                            if(id == this.dataList[i].id){
                                this.dataList[i].state = 1
                            }
                        }
                    }
                    this.checkMsg=[]
                    this.$message({
                        message: `标记已读成功`,
                        type: 'success'
                    });
                    this.getRead()
                    this.getNoRead()
                }else{
                    this.$message({
                        message: `标记已读失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 全部已读
        allRead(){
            this.post('/Message/clearUnread',{type:this.type}).then((res)=>{
                if(res.success){
                    for(let i in this.dataList){
                        this.dataList[i].state = 1
                    }
                    this.checkMsg=[]
                    this.$message({
                        message: `标记全部已读成功`,
                        type: 'success'
                    });
                    this.getRead()
                    this.getNoRead()
                }else{
                    this.$message({
                        message: `标记全部已读失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 全部删除
        allDel(){
            this.post('/Message/removeAll',{type:this.type}).then((res)=>{
                if(res.success){
                    this.dataList = []
                    this.$store.state.messageList = []
                    this.checkMsg=[]
                    this.totalCount = 0
                    this.AllNum = 0
                    this.$message({
                        message: `全部删除成功`,
                        type: 'success'
                    });
                    this.getRead()
                    this.getNoRead()
                }else{
                    this.$message({
                        message: `全部删除失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        jump(obj){
            if(obj.state==2){
                this.post('/Message/setReadState',{ids:obj.id}).then((res)=>{
                    if(res.success){
                        obj.state=1
                    }
                })
            }
            // const url = this.$router.resolve({path: '/CompanyConsole/IndexEditShow'})
            // let reg = new RegExp("/dist");
            // url.href=url.href.replace(reg,'')
            // window.open(url.href,item.id)
            let url = ''
            if(obj.type==1){
                url='/CompanyConsole/DeviceAlarmList'
            }else if(obj.type==2){
                url='/CompanyConsole/TaskPlan'
            }else if(obj.type==3){
                url='/CompanyConsole/ServicePlan'
            }
            if(url){
              let state = JSON.stringify(this.$store.state)
              sessionStorage.setItem('state',state)
              sessionStorage.setItem('companyId',obj.companyId)
              this.windowOpen(url,obj.companyId)
            }
        }
    },
}
</script>
<style scoped>
    .title-txt{
        text-align: left;
        font-size: 16px;
        padding-left: 16px;
    }
    .type-box{
        background-color: #fff;
        width: 216px;
        position: absolute;
        top: 32px;
        left:16px;
        bottom: 0;
        padding: 12px 12px;
        box-sizing: border-box;
    }
    .type-box p{
        line-height: 48px;
        font-size: 14px;
        border-bottom: 1px solid #e5e5e5;
        cursor: pointer;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top:-43px;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        display: inline-block;
        width: 105px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
        float: left;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 32px;
        left: 247px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        max-height: 550px !important;
        height: 550px;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-top: 24px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:0;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
        width: 100%;
		/* margin-top: 42px; */
    }
    .fouc-bg{
        background: #e3e3e3;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 20%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-289px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 4px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .list-details.block{
        width: 97.6% !important;
        margin: 0 auto;
        background-color: #eeeeee !important;
        display: block ;
        text-align: left;
    }
    .list-details.block span{
        font-size: 14px;
        border: 1px solid #dcdcdc;
        display: inline-block;
        padding:7px 18px;
        background-color: #fff;
        line-height: 14px;
        margin-left:12px;
        border-radius: 5px;
        cursor: pointer;
    }
    .list-details.block span:hover{
        background-color: #f6f6f9;
    }
    .children-view #Message{
        margin-top: 16px;
    }
    .children-view #Message .type-box{
        top: 46px;
    }
    .children-view #Message .list-box{
        margin-top: 12px;
    }
</style>
<style>
    #Message .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #Message .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #Message .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #Message .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #Message .search .el-icon-search{
        line-height: 34px !important;
    }
    #Message .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #Message .popup .el-input__icon{
        line-height: 34px !important;
    }
    #Message .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Message/Message.vue